import { LogicBlockIndex } from '@morph-mapper/node-logic';
import { createNodeInstance } from '../node';
import { defaultIdFactory } from '../commands/utils/id';
import { TERMINAL_NODE_ID } from '../../config/graph';
import { EdgeInstance, NodeInstance } from '../../types';

type IteratorGraphPreset = {
  nodes: Record<string, NodeInstance>;
  edges: Record<string, EdgeInstance>;
  iteratorNodeId: string;
};

export const buildIteratorGraphPreset = (
  type: LogicBlockIndex,
  logicBlocks: any
): IteratorGraphPreset => {
  const iteratorNodeId = defaultIdFactory.nodeId();
  const edgeId = defaultIdFactory.edgeId();
  const iteratorNode: NodeInstance = {
    ...createNodeInstance(
      { id: iteratorNodeId, kind: type },
      logicBlocks as any
    ),
    id: iteratorNodeId,
  };

  return {
    nodes: {
      [TERMINAL_NODE_ID]: {
        id: TERMINAL_NODE_ID,
        kind: 'terminal',
        options: {},
      },
      [iteratorNodeId]: iteratorNode,
    },
    edges: {
      [edgeId]: {
        id: edgeId,
        order: 0,
        from: {
          nodeId: iteratorNodeId,
          portId: '1',
        },
        to: {
          nodeId: TERMINAL_NODE_ID,
          portId: 'child',
        },
      },
    },
    iteratorNodeId,
  };
};
